export enum EntityCollection {
  ABWESENHEITEN = 'abwesenheiten',
  PERSON = 'adornisuser',
  ENTITY_VERSION_COLLECTION = 'entityversions',
  BESTELLUNG = 'bestellungen',
  PRODUKT = 'produkte',
  BUCHUNG = 'buchung',
  PRODUKT_ZUWEISUNG = 'produkt-zuweisung',
  SG_CONFIG = 'sg-config',

  GRUPPE = 'gruppen',
}
